import i18n from "../i18n";


export const BANDS = {
  danger: "#E53935",
  warning: "#FB8C00",
  good: "#43A047",
  excellent: "#00E676",
};

export const bandColor = (b) => BANDS[b] || "#D4AF37";

// Couleurs FIXES par issue 1/N/2, cohérentes dans toute l'app.
// home = bleu (convention "1") -> distinct du vert #00E676 réservé à la
// performance/confiance/value ; draw = jaune ; away = rouge.
export const OUTCOME_COLORS = { home: "#3B9EFF", draw: "#EAB308", away: "#FF5252" };
export const outcomeColor = (k) => OUTCOME_COLORS[k] || "#D4AF37";

export const scoreBand = (v) =>
  v < 40 ? "danger" : v < 60 ? "warning" : v < 80 ? "good" : "excellent";

export function formatApiError(detail) {
  if (detail == null) return i18n.t("common.generic_error");
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
